if (!customElements.get('yc-blessing5')) {
  customElements.define('yc-blessing5', class YCBlessing5 extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.video = this.querySelector('video');
      this.iframe = this.querySelector('iframe');
      
      if (this.video || this.iframe) {
        this.initObserver();
      }
    }

    initObserver() {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.25 // Play when 25% of the element is visible
      };

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.playMedia();
          } else {
            this.pauseMedia();
          }
        });
      }, options);

      this.observer.observe(this);
    }

    playMedia() {
      if (this.video) {
        this.video.play().catch(error => {
          console.warn('Video autoplay failed:', error);
        });
      }
      
      if (this.iframe) {
        // For YouTube/Vimeo iframes, we can't easily play/pause without API
        // But if we use autoplay=1 in URL, it might already be handled by browser if we just show it.
        // However, standard practice is to use postMessage for API control.
        this.controlIframe('play');
      }
    }

    pauseMedia() {
      if (this.video) {
        this.video.pause();
      }
      
      if (this.iframe) {
        this.controlIframe('pause');
      }
    }

    controlIframe(action) {
      if (!this.iframe) return;
      
      const isYouTube = this.iframe.src.includes('youtube.com');
      const isVimeo = this.iframe.src.includes('vimeo.com');
      
      if (isYouTube) {
        const message = action === 'play' ? '{"event":"command","func":"playVideo","args":""}' : '{"event":"command","func":"pauseVideo","args":""}';
        this.iframe.contentWindow.postMessage(message, '*');
      } else if (isVimeo) {
        const message = action === 'play' ? '{"method":"play"}' : '{"method":"pause"}';
        this.iframe.contentWindow.postMessage(message, '*');
      }
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }
  });
}
